<div class="order-details-row-view" [ngClass]="{'order-details-row-view--clickable': !!selectRowClick }"
  (click)="selectRowClick && selectRowClick()">
  <div class="row g-0">
    <div *ngIf="originConfig.actualData" class="col">
      <app-order-details-card-view [headerName]="'.Origin'">
        <app-component-resolver [data]="originConfig.actualData" [config]="originConfig">
        </app-component-resolver>
      </app-order-details-card-view>
    </div>
    <div *ngIf="destinationConfig.actualData" class="col">
      <app-order-details-card-view [headerName]="'.Destination'">
        <app-component-resolver [data]="destinationConfig.actualData" [config]="destinationConfig">
        </app-component-resolver>
      </app-order-details-card-view>
    </div>
    <div *ngIf="cargoConfig.actualData" class="col">
      <app-order-details-card-view [headerName]="'.Cargo'">
        <app-component-resolver [data]="cargoConfig.actualData" [config]="cargoConfig">
        </app-component-resolver>
      </app-order-details-card-view>
    </div>
    <div *ngIf="clientConfig.actualData" class="col">
      <app-order-details-card-view [headerName]="clientConfig.actualData.headerName || '.Shipper'">
        <app-component-resolver [data]="clientConfig.actualData" [config]="clientConfig">
        </app-component-resolver>
      </app-order-details-card-view>
    </div>
    <div *ngIf="priceDetailsConfig.actualData" class="col">
      <app-order-details-card-view [headerName]="'.Price'">
        <app-component-resolver [data]="priceDetailsConfig.actualData" [config]="priceDetailsConfig">
        </app-component-resolver>
      </app-order-details-card-view>
    </div>
  </div>
</div>